import values from 'lodash/values';

import { convertRelationsList } from '../../../../utils/converters/convertListWithLocalization';
import { CARE_ROLE } from '../../../../constants/props';

export default function(
  formatMessage,
  rolesOptions = CARE_ROLE,
  hasDescription = true,
) {
  const careRoleOptions = values(rolesOptions).map(item => {
    return { value: item, className: 'bb b--light-gray' };
  });
  return convertRelationsList(careRoleOptions, formatMessage, hasDescription);
}



// WEBPACK FOOTER //
// ./src/components/common/FieldsList/utils/handleRolesOptions.js